import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function EnableIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M18.36 6.64a9 9 0 1 1-12.73 0"
    }), /*#__PURE__*/_jsx("line", {
      x1: "12",
      y1: "2",
      x2: "12",
      y2: "12"
    })]
  });
}